<template>
  <div>
    <g-master name="forms"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :parentData="parentData"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Cargo')"
                        :selectConfig="{mode:'multiple'}"
                        :formItemConfig="fiOptions"
                        endpoint="jobs"
                        :decorator="['id_job']">
            </g-dropdown>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>

<script>
  export default {
    props: ['id_cc'],
    data () {
      return {
        paramsT: {},
        endpointExcel: 'cc_jobs_/downloadExcel',
        fileNameExcel: 'Cargos',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'cc_jobs',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Cargo', dataIndex: 'job_name', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_cc: this.id_cc
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Cc/CcJobs.vue